import EntryList from './EntryList';
import useFetch from './useFetch';
import YouTubeCounter from './components/YouTube/YouTubeCounter';

const API_BASE =
  process.env.REACT_APP_API_BASE || 'https://helpmediy.org:3001/api';

const Home = ({ showStats = true, entryAction, refreshKey = 0 }) => {
  const {
    data: entries,
    isPending,
    error,
  } = useFetch(`${API_BASE}/entries?refresh=${refreshKey}`);

  // render this conditionally on entries being set via fetch
  return (
    <div className="home">
      {showStats && (
        <div className="section-card">
          <YouTubeCounter />
        </div>
      )}
      {error && <div>{error}</div>}
      {isPending && <div>Loading...</div>}
      {entries && (
        <EntryList entries={entries} title="All Entries" action={entryAction} />
      )}
    </div>
  );
};

export default Home;
